import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, FormRowBase } from '../form-row-base/form-row-base'
import { CoreService } from '../../../services'
import { Currency } from 'depoto-core/src/entities'

@Component({
  selector: 'form-row-input',
  templateUrl: 'form-row-input.component.html',
  styles: [
    `
      .form-group .input-group .input-group-text {
        padding-top: 10px;
      }
    `,
  ],
  styleUrls: ['./form-row-input.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR(FormRowInputComponent)],
})
export class FormRowInputComponent extends FormRowBase implements OnInit, OnChanges {
  @ViewChild('formRow') formRow: ElementRef
  @Input() label: string
  @Input() elementName: string
  @Input() tooltipLabel: string
  @Input() tooltipIcon: string
  @Input() model: string | number
  @Input() modelToggle: boolean
  @Output() modelChange: EventEmitter<any> = new EventEmitter()
  @Output() valueChangeNative: EventEmitter<any> = new EventEmitter()
  @Output() onKeyPress: EventEmitter<KeyboardEvent> = new EventEmitter()
  @Output() onBlur: EventEmitter<any> = new EventEmitter()
  @Output() onFocused: EventEmitter<any> = new EventEmitter()
  @Input() inputType = 'text'
  @Input() inputMultiple = false
  @Input() inputDisabled = false
  @Input() inputRequired = false
  @Input() numberMin = null
  @Input() numberMax = null
  @Input() maxlength = this.inputType === 'text' ? 255 : undefined
  @Input() noMarginBottom = false
  @Input() classes: string[] = []
  @Input() icon = null
  @Input() translateBarcode = false
  @Input() replaceComma = false
  @Input() appendBtnLabel: string
  @Input() appendBtnClasses: string[] = []
  @Input() appendBtnIcon: string
  @Input() appendBtnTitle = ''
  @Output() onAppendBtnEvent: EventEmitter<any> = new EventEmitter()
  @Input() trackCategory = 'event-click-input'
  @Input() trackAction: string
  @Input() appendCheckboxLabel: string
  @Input() appendCheckboxValue: boolean
  @Output() appendCheckboxValueChange: EventEmitter<boolean> = new EventEmitter()
  @Input() appendUnitCm: boolean
  @Input() appendUnitKg: boolean
  @Input() appendUnitCurrency: boolean
  @Input() appendUnitPercent: boolean
  @Input() appendCustomText: string
  @Input() isLoginInput: boolean
  @Input() appendCheckboxShow = false
  @Input() appendToggleShow = false
  @Input() formControlName: string
  @Input() formGroup: UntypedFormGroup
  @Input() required: boolean
  @Input() requiredCssClass: any
  @Input() showErrorBorder: boolean
  @Input() placeholder = ''
  @Input() readonly = false
  @Input() maxWidthPx: string | number = 'none'
  @Input() currency: Currency
  @Input() disallowTabNavToBtn: boolean
  @Input() dataCyAttribute: string
  private classesDefault = 'form-control'
  classesString = ''
  iconClassesString = ''
  isFocused: boolean
  isErrorShown: boolean
  constructor(private core: CoreService) {
    super()
  }

  ngOnInit() {
    if (!this.currency?.id) this.currency = this.core.services.user.user?.company?.currency
    this.updateComponent()
    this.initFormControl()
  }

  ngOnChanges() {
    this.updateComponent()
  }

  onBtnClick(event: any): void {
    this.onAppendBtnEvent.emit(event)
  }

  onInputValueChange(event: any): void {
    if (this.numberMax !== null && Number(event.target.value) > Number(this.numberMax))
      event.target.value = String(this.numberMax)
    this.onChange(event, this.numberMax)
    this.valueChangeNative.emit(event)
  }

  onInputKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onChange(event, this.numberMax)
      this.isFocused = false
    }
    this.onKeyPress.emit(event)
  }

  onFocus(isFocused: boolean) {
    this.isFocused = isFocused
    if (!isFocused && !this.control.valid) {
      this.isErrorShown = true
    }
    if (!isFocused) {
      this.onBlur.emit()
    } else {
      this.onFocused.emit()
    }
  }

  onAppendedCheckboxChange(value: boolean): void {
    this.onChange({ type: 'toggle', target: { value } }, this.numberMax)
    this.appendCheckboxValueChange.emit(value)
  }

  private updateComponent(): void {
    let classesAdditional = ''
    if (this.classes && this.classes.length > 0) {
      this.classes.forEach(cls => {
        classesAdditional += ' ' + cls
      })
    }
    this.classesString = this.classesDefault + classesAdditional

    let iconClasses = ''
    if (this.icon && this.icon.length > 0) {
      iconClasses += this.icon.split('-')[0]
      iconClasses += ' ' + this.icon.replace('far-', 'fa-').replace('fas-', 'fa-')
    }
    this.iconClassesString = iconClasses
    if (!this.trackAction) {
      this.trackAction = this.label
    }
  }
}
